import { ACTION_TYPES, Actions } from "./types"
import { Action } from "./actions"

export const STOCK_DOCUMENT_ACTION_TYPES = ACTION_TYPES
export const StockDocumentAction = Action
export type StockDocumentActions = Actions




// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/actions/index.ts